import React from "react";
import PropTypes from "prop-types";
import { Grid, Divider, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  textRight: {
    textAlign: "right"
  },
  cardPriceDivider: {
    backgroundColor: "rgba(255, 255, 255, 0.8)"
  }
}));

const PriceDetails = props => {
  const { invoiceEstimate, darkBg } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={6}>
        {t('planPrice')}
      </Grid>
      <Grid item xs={6} className={classes.textRight}>
        {invoiceEstimate.SubTotal.Amount.toFixed(2)}
        &euro;
      </Grid>
      <Grid item xs={6}>
        {t('discount')}
      </Grid>
      <Grid item xs={6} className={classes.textRight}>
        {(0 - invoiceEstimate.Discount.Amount).toFixed(2)}
        &euro;
      </Grid>
      <Grid item xs={12}>
        <Divider className={clsx(darkBg ? classes.cardPriceDivider : "")} />
      </Grid>
      <Grid item xs={6}>
        {invoiceEstimate.Tax.Description}
      </Grid>
      <Grid item xs={6} className={classes.textRight}>
        {invoiceEstimate.Tax.Money.Amount.toFixed(2)}
        &euro;
      </Grid>
      <Grid item xs={12}>
        <Divider className={clsx(darkBg ? classes.cardPriceDivider : "")} />
      </Grid>
      <Grid item xs={6}>
        <strong>{t('total')}</strong>
      </Grid>
      <Grid item xs={6} className={classes.textRight}>
        <strong>
          {invoiceEstimate.Total.Amount.toFixed(2)}
          &euro;
        </strong>
      </Grid>
    </Grid>
  );
};

PriceDetails.propTypes = {
  invoiceEstimate: PropTypes.object.isRequired,
  darkBg: PropTypes.bool,
};

export default PriceDetails;
